export default __webpack_public_path__ + "7778b901047c4af22e72fd5f3710c2cf.png";